import { render, staticRenderFns } from "./OffsetComparisonOptions.vue?vue&type=template&id=53c7a2e2&scoped=true"
import script from "./OffsetComparisonOptions.vue?vue&type=script&lang=js"
export * from "./OffsetComparisonOptions.vue?vue&type=script&lang=js"
import style0 from "./OffsetComparisonOptions.vue?vue&type=style&index=0&id=53c7a2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c7a2e2",
  null
  
)

export default component.exports